const base = '';

export const getSubscription = base+'/api/v1/subscriptions';

export const postSubscription = base+'/api/v1/unsubscribe';
